exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-7c7ccad0] {\n  width: 100%;\n  height: 100%;\n}\n.storeReport[data-v-7c7ccad0] {\n  width: 100%;\n  height: 100%;\n}\niframe[data-v-7c7ccad0] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
